import { TableCard } from 'app/components'
import { TelekitsListHeader } from './components/header/TelekitsListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { TelekitsTable } from './table/TelekitsTable'

const TelekitsList = () => {
  return (
    <TableCard>
      <TelekitsListHeader />
      <TelekitsTable />
    </TableCard>
  )
}

export const TelekitsListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <TelekitsList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
